import { DatePicker, Modal } from "antd"
import Breadcrumbs from "components/Common/Breadcrumb"
import { axiosbaseurl } from "../config"
import moment from "moment"
import React, { useEffect, useMemo, useState } from "react"
import { FaChevronLeft, FaChevronRight, FaEye } from "react-icons/fa"
import { MdAdd } from "react-icons/md"
import { Container } from "reactstrap"
import PermittedComponent from "PermittedComponent"
import { usePermissionData } from "../AppContext"
import { RiArrowUpDownFill } from "react-icons/ri"

const { RangePicker } = DatePicker

const AuditLogs = () => {
  document.title = "Audit Logs | Return First Investments"

  const { checkAccess } = usePermissionData()

  const [Activity, setModal] = useState(false)
  const [Loading, setLoading] = useState(false)
  const [Data, setData] = useState([])
  const [Users, setUsers] = useState([])
  const [CurrentItem, setCurrentItem] = useState({})

  useEffect(() => {
    getData()
  }, [])

  async function getData() {
    setLoading(true)
    try {
      const response = await axiosbaseurl.get(`audit-logs`)
      if (response?.data?.success) {
        setUsers(response?.data?.data)
        setData(response?.data?.data)
      }
    } catch (e) {
      console.log("Error", e.response.data.message)
    } finally {
      setLoading(false)
    }
  }

  const filterByName = e => {
    const filteredData = Users.filter(
      session =>
        session.moduleName
          .toLowerCase()
          .includes(e.target.value.toLowerCase()) ||
        session.actionPerformed
          .toLowerCase()
          .includes(e.target.value.toLowerCase()) ||
        session?.actionDescription
          ?.toLowerCase()
          .includes(e.target.value.toLowerCase())
    )

    setData(filteredData)
  }

  const [page, setPage] = useState(1)

  useEffect(() => window.scrollTo(0, 0), [])

  const [items_perpage, setItemsPerPage] = useState(10)

  const total_pages = Math.ceil(Data?.length / items_perpage)

  const changePage = pagecount => {
    if (pagecount > 0 && pagecount <= total_pages) {
      setPage(pagecount)
      window.scrollTo(0, 0)
    }
  }

  const handleModal = item => {
    setCurrentItem(item)
    setModal(true)
  }

  const [dateRange, setDateRange] = useState("")

  const handleFilter = ([start, end]) => {
    if (!start || !end) {
      setData(Users) // Show all blogs if range is invalid or empty
      return
    }
    const startCustom = new Date(start)
    const endCustom = new Date(end)
    endCustom.setHours(23, 59, 59, 999)
    const filtered = Users.filter(product => {
      const orderDate = new Date(product.createdAt)
      return orderDate >= startCustom && orderDate <= endCustom
    })
    setData(filtered)
  }

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  })

  const sortedData = useMemo(() => {
    let sortableItems = [...Data]

    if (sortConfig.key) {
      sortableItems.sort((a, b) => {
        const aValue =
          sortConfig.key === "userName"
            ? a?.user?.userName || ""
            : a[sortConfig.key]
        const bValue =
          sortConfig.key === "userName"
            ? b?.user?.userName || ""
            : b[sortConfig.key]

        if (aValue < bValue)
          return sortConfig.direction === "ascending" ? -1 : 1
        if (aValue > bValue)
          return sortConfig.direction === "ascending" ? 1 : -1
        return 0
      })
    }
    return sortableItems
  }, [Data, sortConfig])

  const final_data = sortedData.slice(
    (page - 1) * items_perpage,
    page * items_perpage
  )

  const requestSort = key => {
    let direction = "ascending"
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending"
    }
    setSortConfig({ key, direction })
  }

  return (
    <React.Fragment>
      <PermittedComponent isAccess={checkAccess(7, 1)}>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs title={""} breadcrumbItem={"Audit Logs"} />

            <div className="card p-2 py-3">
              <div className="d-flex flex-column flex-xl-row align-items-center justify-content-between">
                <div className="date-range-picker">
                  <RangePicker
                    onChange={(value, dateString) => {
                      setDateRange(dateString)
                      handleFilter(dateString)
                    }}
                    className="form-select1 rounded-5 py-2 text-dark w-100"
                    placement="bottom"
                  />
                </div>
                <div className="d-flex mt-3 mt-xl-0 align-items-center justify-content-between">
                  <div className="search-box position-relative">
                    <input
                      className="form-control form-control1 ps-6"
                      placeholder="Search Log"
                      onChange={filterByName}
                    />
                    <i className="bx bx-search-alt search-icon"></i>
                  </div>

                  <select
                    className="form-select form-select1 py-2 ms-3 fs-6 rounded-5"
                    value={items_perpage}
                    onChange={e => setItemsPerPage(e.target.value)}
                    style={{ width: "110px" }}
                  >
                    <option value="5">Show 5</option>
                    <option value="10">Show 10</option>
                    <option value="20">Show 20</option>
                    <option value="30">Show 30</option>
                  </select>
                </div>
              </div>
              <div className="table-responsive mt-4">
                <table className="mb-0 table Custom-Table">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("actionPerformed")}
                      >
                        Action Performed{" "}
                        {sortConfig.key === "actionPerformed" ?
                          (sortConfig.direction === "ascending" ? "🔼" : "🔽") : (
                            <RiArrowUpDownFill size={18}/>
                          )}
                      </th>
                      <th>Action Description</th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("userName")}
                      >
                        Performed By{" "}
                        {sortConfig.key === "userName" ?
                          (sortConfig.direction === "ascending" ? "🔼" : "🔽"): (
                            <RiArrowUpDownFill size={18}/>
                            )}
                      </th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("createdAt")}
                      >
                        Date{" "}
                        {sortConfig.key === "createdAt" ?
                          (sortConfig.direction === "ascending" ? "🔼" : "🔽"): (
                            <RiArrowUpDownFill size={18}/>
                          )}
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {final_data.length === 0 && (
                      <tr>
                        <td colSpan={6}>No Audit Log Found</td>
                      </tr>
                    )}
                    {final_data?.map((item, index) => (
                      <tr key={item?.id}>
                        <td>{(page - 1) * items_perpage + index + 1}</td>
                        <td>{item?.actionPerformed}</td>
                        <td>{item?.actionDescription?.slice(0, 40)}..</td>
                        <td>{item?.user?.userName || "--"}</td>
                        <td>
                          {moment(item?.createdAt).format("DD MMMM YYYY")}
                        </td>
                        <td>
                          <button
                            className="btn Edit-Button"
                            onClick={() => handleModal(item)}
                          >
                            <FaEye /> View
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="d-flex flex-column flex-xl-row align-items-center justify-content-between my-4 px-2">
                <p className="mb-0 fs-7">
                  Showing {final_data?.length} out of {Data?.length} logs.
                </p>
                <div className="d-flex mt-3 mt-xl-0 justify-content-md-start justify-content-center flex-wrap">
                  <div
                    className={`bd-number-pagination rounded-2 me-2 fs-5`}
                    onClick={() => changePage(page - 1)}
                    style={{ cursor: "pointer" }}
                  >
                    <FaChevronLeft />
                  </div>
                  {(() => {
                    const maxVisiblePages = 5
                    const startPage = Math.max(
                      1,
                      page - Math.floor(maxVisiblePages / 2)
                    )
                    const endPage = Math.min(
                      total_pages,
                      startPage + maxVisiblePages - 1
                    )
                    const visiblePages = []

                    for (let i = startPage; i <= endPage; i++) {
                      visiblePages.push(i)
                    }

                    return visiblePages.map(pagecount => (
                      <div
                        key={pagecount}
                        className={`bd-number-pagination cursor-pointer rounded-2 me-1 fs-5 ${
                          page === pagecount ? "activepage" : ""
                        }`}
                        style={{ cursor: "pointer" }}
                        onClick={() => changePage(pagecount)}
                      >
                        {pagecount < 10 ? "0" + pagecount : pagecount}
                      </div>
                    ))
                  })()}
                  <div
                    className={`bd-number-pagination cursor-pointer rounded-2 ms-2 fs-5`}
                    onClick={() => changePage(page + 1)}
                    style={{ cursor: "pointer" }}
                  >
                    <FaChevronRight />
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
        <Modal
          open={Activity}
          onCancel={() => setModal(false)}
          footer={false}
          title="Log Details"
          width={900}
          bodyStyle={{ padding: "0" }}
          centered
        >
          <div className="bg-gradientt p-4">
            <table
              className="table Cutom-popup-table"
              style={{ verticalAlign: "middle" }}
            >
              <tbody>
                <tr>
                  <th className="col-3 text-green p-3">Date & Time</th>
                  <td className="p-3">
                    {moment(CurrentItem?.createdAt).format(
                      "DD MMMM YYYY | hh:mm A"
                    )}
                  </td>
                </tr>

                <tr>
                  <th className="col-3 text-green p-3">Module Name</th>
                  <td className="p-3">{CurrentItem?.moduleName}</td>
                </tr>

                <tr>
                  <th className="col-3 text-green p-3">Action</th>
                  <td className="p-3">{CurrentItem?.actionDescription}</td>
                </tr>

                {CurrentItem?.deletedData && (
                  <tr>
                    <th className="col-2">Deleted Data</th>
                    <td>
                      <div className="responsive-table">
                        <table border="1" className="table">
                          <tbody className="text-white">
                            {Object.entries(
                              JSON.parse(CurrentItem?.deletedData)
                            ).map(([key, value]) => (
                              <tr key={key}>
                                <th className="py-2 ">
                                  {key
                                    .replace(/([A-Z])/g, " $1")
                                    .replace(/^./, str => str.toUpperCase())}
                                </th>
                                <td className="py-2">
                                  {moment(value).format("DD MMMM, YYYY ") !==
                                    "Invalid date" &&
                                  value.length > 8 &&
                                  value.includes("-") ? (
                                    moment(value).format("DD MMMM, YYYY ")
                                  ) : (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: value || "--",
                                      }}
                                      style={{
                                        textWrap: "wrap",
                                        lineBreak: "anywhere",
                                      }}
                                    />
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                )}

                {CurrentItem?.updatedData && (
                  <tr>
                    <th className="col-2">Updated Data</th>
                    <td>
                      <div className="responsive-table">
                        <table border="1" className="table">
                          <tbody className="text-white">
                            {Object.entries(
                              JSON.parse(CurrentItem?.updatedData)
                            ).map(([key, value]) => (
                              <tr key={key}>
                                <th className="py-2 col-3">
                                  {key
                                    .replace(/([A-Z])/g, " $1")
                                    .replace(/^./, str => str.toUpperCase())}
                                </th>
                                <td className="py-2">
                                  {moment(value).format("DD MMMM, YYYY ") !==
                                    "Invalid date" &&
                                  value.length > 8 &&
                                  value.includes("-") ? (
                                    moment(value).format("DD MMMM, YYYY ")
                                  ) : (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: value || "--",
                                      }}
                                      style={{
                                        wordWrap: "break-word",
                                        whiteSpace: "pre-wrap",
                                        overflowWrap: "anywhere",
                                      }}
                                    />
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                )}

                {CurrentItem?.previousData && (
                  <tr>
                    <th className="col-2">Previous Data</th>
                    <td>
                      <div className="responsive-table">
                        <table border="1" className="table">
                          <tbody className="text-white">
                            {Object.entries(
                              JSON.parse(CurrentItem.previousData)
                            ).map(([key, value]) => (
                              <tr key={key}>
                                <th className="py-2 col-3 ">
                                  {key
                                    .replace(/([A-Z])/g, " $1")
                                    .replace(/^./, str => str.toUpperCase())}
                                </th>
                                <td className="py-2">
                                  {moment(value).format("DD MMMM, YYYY ") !==
                                    "Invalid date" &&
                                  value.length > 8 &&
                                  value.includes("-") ? (
                                    moment(value).format("DD MMMM, YYYY ")
                                  ) : (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: value || "--",
                                      }}
                                      style={{
                                        wordWrap: "break-word",
                                        whiteSpace: "pre-wrap",
                                        overflowWrap: "anywhere",
                                      }}
                                    />
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                )}
                {CurrentItem?.createdData && (
                  <tr>
                    <th className="col-2">Created Data</th>
                    <td>
                      <div className="table-responsive">
                        <table border="1" className="table">
                          <tbody className="text-white">
                            {Object.entries(
                              JSON.parse(CurrentItem?.createdData)
                            ).map(([key, value]) => (
                              <tr key={key}>
                                <th className="py-2 ">
                                  {key
                                    .replace(/([A-Z])/g, " $1")
                                    .replace(/^./, str => str.toUpperCase())}
                                </th>
                                <td className="py-2">
                                  {moment(value).format("DD MMMM, YYYY ") !==
                                    "Invalid date" &&
                                  value.length > 8 &&
                                  value.includes("-") ? (
                                    moment(value).format("DD MMMM, YYYY ")
                                  ) : (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: value || "--",
                                      }}
                                      style={{
                                        wordWrap: "break-word",
                                        whiteSpace: "pre-wrap",
                                        overflowWrap: "anywhere",
                                      }}
                                    />
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Modal>
      </PermittedComponent>
    </React.Fragment>
  )
}
export default AuditLogs
